import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
import { useEffect } from 'react';
import { $createImageNode, ImagePayload } from './ImageNode';
import { $insertNodeToNearestRoot } from '@lexical/utils';

export const INSERT_IMAGE_COMMAND = createCommand<ImagePayload>('INSERT_IMAGE_COMMAND');

const InsertImagePlugin = () => {
  const [editor] = useLexicalComposerContext();

  const registerInserImageCommand = () => {
    editor.registerCommand(INSERT_IMAGE_COMMAND, (payload: ImagePayload) => {
      $insertNodeToNearestRoot($createImageNode(payload));
      return true;
    }, COMMAND_PRIORITY_EDITOR);
  };

  useEffect(registerInserImageCommand, []);

  return null;
}

export default InsertImagePlugin
